define('presentation/account/sidebar/presentationObjects/vanityAddPresentationObject',[], function () {
    return function () {
        let self = this;

        self.phoneNumber = ko.observable("");
        self.countryAbbreviation = ko.observable("us");
        self.countryCode = ko.observable("");
    };
});
